module.exports = __webpack_public_path__ + "img/logo.cf2e8937.png";